export const isIPhone = () => /iPhone/.test(navigator.userAgent);
